import { Mailbox, Phone } from '@phosphor-icons/react';
import { useEDCFlow } from '@smvtech/x-flux';
import React from 'react'

const NoApplicant = () => {
    const { order } = useEDCFlow();
    return (
        <div className="h-screen bg-[#F7F7F7] p-6">
            <div className="h-full flex items-center justify-center">
                <div className="w-full max-w-2xl bg-white rounded-xl shadow-sm px-6 py-10 md:px-10 md:py-14">
                    <div className="mx-auto flex flex-col items-center gap-8 text-center">

                        <img
                            src="https://stampmyvisa-public.s3.ap-south-1.amazonaws.com/images/common/lost-traveller.png"
                            alt="Traveller not found"
                            className="w-80 md:w-96"
                        />

                        <div className="flex flex-col gap-3">
                            <h2 className="text-xl md:text-2xl font-semibold text-gray-900">
                                We couldn’t find your application
                            </h2>

                            <p className="text-gray-600 max-w-md mx-auto leading-relaxed">
                                Sorry about this. It looks like we’re unable to locate your details right now.
                                Please reach out to us and we’ll help you resolve this quickly.
                            </p>
                        </div>

                        <div className="w-full max-w-xs h-px bg-gray-200" />

                        <div className="flex flex-col gap-3 text-gray-700">
                            <div className="flex items-center justify-center gap-3">
                                <Phone size={20} className="text-blue-500" />
                                <span className="text-sm md:text-base">
                                    {order?.organisation?.point_of_contact.mobile_number}
                                </span>
                            </div>

                            <div className="flex items-center justify-center gap-3">
                                <Mailbox size={20} className="text-blue-500" />
                                <span className="text-sm md:text-base">
                                    {order?.organisation?.point_of_contact.email}
                                </span>
                            </div>
                        </div>

                        <p className="text-xs text-gray-500">
                            Our support team is available to guide you through the next steps.
                        </p>

                    </div>
                </div>
            </div>
        </div>
    )
};

export default NoApplicant;